export default __webpack_public_path__ + "static/benifitImage1-beeaa4c513cd2cc1c04db47d10ebf733.webp";